import React, { useState } from "react";
import LogoutIcon from "@mui/icons-material/Logout";
import { useNavigate } from "react-router-dom";

// import JS files
import { MenuItem } from "../../../utils";
import { useAuth } from "../../../context/AuthContext";
import { AdminMenuItems } from "./AdminMenuItems";
import MuiDropDown from "../../shares/MuiDropDown";
import MuiBadge from "../../shares/MuiBadge";
import { useUserData } from "../../../context/UserDataContext";

// import Others files

const AdminSideBar = (props) => {
  let windowWidth = window.screen.width;
  const navigate = useNavigate();

  const { authDispatch } = useAuth();
  const { userData } = useUserData();

  return (
    <>
      {/* Desktop Navbar Part */}
      <div className="hidden md:flex items-center justify-between">
        <div>
          <span className="font-bold text-yellow-200 text-base">
            فروشگاه زرسان <span className="text-sm text-white">/ مدیریت</span>
          </span>
        </div>
        <div className="flex items-center">
          {AdminMenuItems.map((box, index) => {
            return (
              <>
                {box.items.length > 0 ? (
                  <MuiDropDown
                    header={box.header}
                    HeaderIcon={box.headerIcon}
                    menuList={box.items}
                    activeLink={props.activeLink}
                  />
                ) : box.haveBadge == true ? (
                  <MuiBadge count={userData?.chat_num}>
                    <div
                      onClick={() => navigate(box.route)}
                      className="flex items-center text-white cursor-pointer mr-4"
                    >
                      <box.headerIcon />
                      <span className="sidebar-header">{box.header}</span>
                    </div>
                  </MuiBadge>
                ) : (
                  <div
                    onClick={() => navigate(box.route)}
                    className="flex items-center text-white cursor-pointer mr-4"
                  >
                    <box.headerIcon />
                    <span className="sidebar-header">{box.header}</span>
                  </div>
                )}
              </>
            );
          })}
        </div>
        <div
          className="text-sm flex items-center text-white cursor-pointer bg-transparent rounded-lg p-2 font-bold transition-all hover:bg-white hover:text-rose-500"
          onClick={() => authDispatch({ type: "LOGOUT" })}
        >
          <LogoutIcon />
          <span className="mr-2">خروج</span>
        </div>
      </div>
      {/* End Desktop Navbar Part */}
      {/* Mobile Navbar Part */}
      <div className="md:hidden">
        <div className="text-center mb-6 md:mb-10">
          <span className="font-bold text-yellow-200 text-2xl md:text-3xl border-b-4 border-yellow-200">
            فروشگاه زرسان
          </span>
        </div>
        <div className="bg-yellow-200 rounded-md py-2 flex justify-center mb-4 md:mb-10">
          <span className="font-bold">مدیریت</span>
        </div>
        {AdminMenuItems.map((box, index) => {
          return (
            <>
              <div className="bg-white rounded-md p-4 mb-6">
                {box.items.length > 0 ? (
                  <>
                    <div className="flex items-center mb-4">
                      <box.headerIcon />
                      <span className="sidebar-header">{box.header}</span>
                    </div>
                    <ul>
                      {box.items.map((item, index) => {
                        return (
                          <MenuItem
                            route={item.route}
                            isActive={
                              props.activeLink == item.isActive ? true : false
                            }
                            text={item.name}
                          />
                        );
                      })}
                    </ul>
                  </>
                ) : (
                  <>
                    {box.haveBadge ? (
                      <>
                        <MuiBadge count={userData?.chat_num}>
                          <div
                            className="flex items-center"
                            onClick={() => navigate(box.route)}
                          >
                            <box.headerIcon />
                            <span className="sidebar-header">{box.header}</span>
                          </div>
                        </MuiBadge>
                      </>
                    ) : (
                      <>
                        <div
                          className="flex items-center"
                          onClick={() => navigate(box.route)}
                        >
                          <box.headerIcon />
                          <span className="sidebar-header">{box.header}</span>
                        </div>
                      </>
                    )}
                  </>
                )}
              </div>
            </>
          );
        })}
        <div
          onClick={() => authDispatch({ type: "LOGOUT" })}
          className="flex items-center cursor-pointer mt-6 rounded-md py-2 px-4 border-2 border-white text-white hover:bg-white hover:text-gray-700 transition-all"
        >
          <LogoutIcon />
          <span className="sidebar-header">خروج</span>
        </div>
      </div>
      {/* End Mobile Navbar Part */}
    </>
  );
};

export default AdminSideBar;
